import React, { useState } from 'react';
import { Instagram } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { TermsModal } from '@/components/auth/TermsModal';
import { CommunityGuidelinesModal } from '@/components/auth/CommunityGuidelinesModal';
import { PrivacyModal } from '@/components/auth/PrivacyModal';
import InterlacedLogoV2 from '@/components/ui/InterlacedLogoV2';

const Footer = () => {
  const [showTerms, setShowTerms] = useState(false);
  const [showGuidelines, setShowGuidelines] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  return (
    <>
      <footer className="relative bg-black border-t border-white/10 py-12 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            {/* Brand */}
            <div className="col-span-1 md:col-span-2">
              <InterlacedLogoV2 variant="horizontal" size="md" as="h3" className="mb-4" />
              <p className="text-white/60 mb-4">
                Conexões exclusivas entre sucesso e ambição.
              </p>
            </div>

            {/* Links */}
            <div>
              <h4 className="text-white font-semibold mb-4">Sobre</h4>
              <ul className="space-y-2">
                <li>
                  <button
                    onClick={() => setShowTerms(true)}
                    className="text-white/60 hover:text-white transition-colors"
                  >
                    Termos de Uso
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => setShowGuidelines(true)}
                    className="text-white/60 hover:text-white transition-colors"
                  >
                    Diretrizes da Comunidade
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => setShowPrivacy(true)}
                    className="text-white/60 hover:text-white transition-colors"
                  >
                    Política de Privacidade
                  </button>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-white font-semibold mb-4">Suporte</h4>
              <ul className="space-y-2">
                <li>
                  <a
                    href="mailto:contato@interlaced.app"
                    className="text-white/60 hover:text-white transition-colors"
                  >
                    contato@interlaced.app
                  </a>
                </li>
                <li>
                  <a
                    href="https://instagram.com/interlaced.app"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-white/60 hover:text-white transition-colors"
                  >
                    <Instagram size={16} />
                    @interlaced.app
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Copyright */}
          <div className="border-t border-white/10 pt-8 text-center text-white/40 text-sm">
            <p>© {new Date().getFullYear()} Interlaced. Todos os direitos reservados.</p>
          </div>
        </div>
      </footer>

      {/* Modals */}
      <TermsModal open={showTerms} onOpenChange={setShowTerms} />
      <CommunityGuidelinesModal open={showGuidelines} onOpenChange={setShowGuidelines} />
      <PrivacyModal open={showPrivacy} onOpenChange={setShowPrivacy} />
    </>
  );
};

export default Footer;
